import React, { Component } from 'react';
import Criterion from './Criterion';

import './Criteria.css';

class Criteria extends Component {
  constructor(props) {
    super();
    this.state = {
    }
  }

  componentDidUpdate() {
    if (!this.props.selectedCriterionInView) {
      this.refs.criteria.scrollTop = this.refs.criteria.children[this.props.currentIndex].offsetTop;
      this.props.revealed();
    }
  }

  render() {
    const criteria = this.props.isEmpty
      ? <div className="message-empty font-color-dark">No matched criterion. Please change your search keyword.</div>
      : this.props.criteria.map((criterion,index) =>
          <Criterion
            clicked={() => this.props.clicked(criterion)}
            key={criterion.label}
            mouseEntered={() => this.props.mouseEntered(index)}
            label={criterion.label}
            isFocused={this.props.currentIndex === index}
            isSelected={this.props.selectedCriteria.has(criterion)}>
          </Criterion>
        );
    return (
      <div className="AS-criteria" ref="criteria">
        {criteria}
      </div>
    )
  }
}

export default Criteria;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/list/Criteria.js